import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import MiniMenu from "../MiniMenu/MiniMenu";
import ActionButton from "../ActionButton/ActionButton";
import Backdrop from "../../UI/Backdrop/Backdrop";
import Warning from "../Warning/Warning";
import DownloadMessage from "../DownloadMessage/DownloadMessage";

import { useOnClickOutside } from "../../../utils/hook/useOnClickOutside";
import usePrintPdf from "../../../utils/hook/usePrintPdf";

import CleanFileIcon from "../../Icon-SVG/CleanFileIcon";
import PrintPdfIcon from "../../Icon-SVG/PrintPdfIcon";

import { ClearCleanFileId, RequestCleanFile } from "../../../store/actions/cdrActions";

import "./styles.scss";

// `buttonVariant="action"` renders the icon + label row-action button used by
// the mail gateway tables; the dashboard keeps the default primary button.
const DoCdr = ({ fileHash, fileId, severity, fileExt, marginal, buttonVariant = "primary" }) => {
  const ref = useRef();
  const dispatch = useDispatch();

  const [menuOpen, setMenuOpen] = useState(false);
  const [showWarning, setShowWarning] = useState(false);

  const cleanFileId = useSelector((state) => state.cdr.cleanFileId);
  const cleanFileLoading = useSelector((state) => state.cdr.cleanFileLoading);
  const showCleanFileInfo = useSelector((state) => state.cdr.showCleanFileInfo);

  const isCurrentComponent = fileId === cleanFileId;

  const loading = cleanFileLoading && isCurrentComponent;

  useOnClickOutside(ref, () => setMenuOpen(false));
  const { downloadOptions, fileName, printPdfHandler } = usePrintPdf(fileHash);

  useEffect(() => {
    if (isCurrentComponent && showCleanFileInfo) setShowWarning(true);
  }, [isCurrentComponent, showCleanFileInfo]);

  const buttonClickHandler = (event) => {
    event.stopPropagation();
    setMenuOpen((prev) => !prev);
  };

  const cleanFileHandler = () => {
    setMenuOpen(false);
    dispatch(RequestCleanFile({ fileId, fileHash }));
  };

  const clickOKHandler = () => {
    dispatch(ClearCleanFileId());
    setShowWarning(false);
  };

  return (
    <div
      className={`do-cdr${buttonVariant === "action" ? " do-cdr--action" : ""}`}
      style={{ marginLeft: marginal }}
      ref={ref}
      onClick={(e) => e.stopPropagation()}>
      {buttonVariant === "action" ? (
        <ActionButton
          icon={<CleanFileIcon width={13} height={13} color="currentColor" />}
          onClick={buttonClickHandler}
          disabled={severity === "not suspicious"}>
          Do CDR
        </ActionButton>
      ) : (
        <button
          className="primary-button"
          onClick={buttonClickHandler}
          disabled={severity === "not suspicious"}>
          Do CDR
        </button>
      )}
      <MiniMenu isOpen={menuOpen} className="dashboard__table__threedots__menu">
        {fileExt !== "pdf" ? (
          <div onClick={cleanFileHandler}>
            <CleanFileIcon color="white" height={21} width={21} /> Clean File
          </div>
        ) : null}
        <div onClick={printPdfHandler}>
          <PrintPdfIcon color="white" height={21} width={21} /> Print Pdf
        </div>
      </MiniMenu>
      <Backdrop show={loading} message="Cleaning file, please wait..." />
      <Backdrop
        show={downloadOptions.downloadStarted}
        message={
          <DownloadMessage
            fileName={fileName}
            loaded={downloadOptions.loaded}
            total={downloadOptions.total}
            progress={downloadOptions.progress}
          />
        }
      />
      <Warning
        textOK="Ok"
        onClickOk={clickOKHandler}
        show={showWarning}
        setShow={setShowWarning}
        text="CDR is completed. After submission analyzed, you can download the clean file from CDR menu under Integrations & CDR"
        article="Information"
        cancelDisable={true}
      />
    </div>
  );
};

export default DoCdr;
